import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApplicationTypes } from 'projects/admin/src/app/models/exemptionFilling';
import { ExternalFilingRequestService } from '../../shared/services/exemptionFilingRequest';

@Component({
  selector: 'app-paymentfailed',
  templateUrl: './paymentfailed.component.html',
  styleUrls: ['./paymentfailed.component.scss'],
})
export class PaymentfailedComponent implements OnInit {
  requestId: any;
  constructor(
    private router: ActivatedRoute,
    private exemptionFilingRequestService: ExternalFilingRequestService,
    private routerService: Router
  ) {}

  ngOnInit(): void {
    console.log(this.router.snapshot.params);
    console.log(atob(this.router.snapshot.params.id));
    this.requestId = +atob(this.router.snapshot.params.id);
    this.exemptionFilingRequestService
      .getExemptionFilingRequestDetail(this.requestId)
      .subscribe((data) => {
        let route = '';
        let appCode = data?.exemptionRequestType?.code;
        if (
          appCode == ApplicationTypes.InitialApplication ||
          appCode == ApplicationTypes.Corrections
        ) {
          route = `/initial/${btoa(this.requestId)}`;
        } else if (
          appCode == ApplicationTypes.RenewalApplication ||
          appCode == ApplicationTypes.SubsequentApplication ||
          ApplicationTypes.ReinstatementsApplication ||
          appCode == ApplicationTypes.SubsequentRenewalApplication ||
          ApplicationTypes.SubsequentReinstatementApplication
        ) {
          route = `/renewal/${btoa(this.requestId)}`;
        }
        
        if (
          appCode == ApplicationTypes.RequestaCopy ||
          appCode == ApplicationTypes.VoluntaryRevocation
        ) {
          route = `/requestcopy/${btoa(this.requestId)}`;
        }
          if (appCode == ApplicationTypes.Corrections) {
            this.routerService.navigate([route], { queryParams: { ifpf: btoa('true'), ica: btoa('true') } });
          } else {
            this.routerService.navigate([route], { queryParams: { ifpf: btoa('true') } });
          }
      });
  }
}
